<template>
  <div class="questions d-flex flex-column">
    <div class="py-5 px-5 text-center" v-for="q in questionData" :key="q._id">
      <h4 class=" mb-3" v-if="$i18n.locale === 'CH'">
        {{ q.questionCh }}
      </h4>
      <h4 class=" mb-3" v-if="$i18n.locale === 'EN'">
        {{ q.questionEn }}
      </h4>
      <p v-if="$i18n.locale === 'CH'">
        {{ q.answerCh }}
      </p>
      <p v-if="$i18n.locale === 'EN'">
        {{ q.answerEn }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: ["questionData"],
};
</script>
